import { render, staticRenderFns } from "./PageExamTest.vue?vue&type=template&id=1a61066c&scoped=true"
import script from "./PageExamTest.vue?vue&type=script&lang=js"
export * from "./PageExamTest.vue?vue&type=script&lang=js"
import style0 from "./PageExamTest.vue?vue&type=style&index=0&id=1a61066c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61066c",
  null
  
)

export default component.exports